<template>
  <div class="container d-flex flex-column align-items-center justify-content-center">
    <div class="col-md-10 col-lg-9 col-xl-8 m-5 mx-auto">
      <div class="card mb-3 rounded-4 overflow-hidden">
        <div class="row g-0">
          <div class="col-sm-5 d-flex align-items-end position-relative overflow-hidden">
            <div class="bg-gradient-circle position-absolute z-0 w-75 h-100"></div>
            <img :src="worriedDoctor" class="img-fluid mt-5 mx-auto z-1" alt="Health">
          </div>

          <!-- A kit still on its way to results, or failed on the way, has the what-to-expect page
               (AncestryLanding) instead: this is for kits that have finished -->
          <div v-if="!$store.getters.kitTests?.autosomal?.purchased && !$store.getters.kitTests?.autosomalStarter?.purchased" class="col-sm-7">
            <div class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
              <h5 class="card-title text-start my-3">No ancestry tests</h5>
              <p class="card-text text-start">
                <small class="text-muted">
                  Discover your unique story with our recent ancestry, motherline, and fatherline upgrade! Uncover ancestral roots and celebrate the marvels of your genetic heritage. Start your exploration now!
                </small>
              </p>
              <router-link :to="{ name: 'AncestryDetails', params: { slug: 'Full-ancestry-upgrade' } }">
                <button class="btn btn-primary">Full upgrade</button>
              </router-link>
              <router-link :to="{ name: 'AncestryDetails', params: { slug: 'Ancestry-Taster' } }">
                <button class="btn btn-primary">Recent Ancestry Taster</button>
              </router-link>
            </div>
          </div>

          <div v-else class="col-sm-7">
            <div class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
              <h5 class="card-title text-start my-3">Failed to load data</h5>
              <p class="card-text text-start">
                <small class="text-muted">Something went wrong loading your data. Please contact support at
                  <a class="text-cobalt-500 font-semibold" href="mailto:help@livingdna.com">help@livingdna.com</a> for further assistance.
                </small>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.bg-gradient-circle {
  background: url('@/assets/gradient-circle.png') no-repeat;
  background-position: right;
  // background-size: cover;
}

img {
  max-height: 330px;
}
</style>

<script setup>
import worriedDoctor from "@/assets/characters/upgrade-required-image.png";
</script>